import regeneratorRuntime from "/app/node_modules/next/dist/compiled/regenerator-runtime/runtime.js";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect, useCallback, useMemo } from 'react';
import { useRouter } from 'next/router';
import WrapPage from '@/components/base/Layout/wrap';
import refreshStore from '@/store/Refresh';
import { observer } from 'mobx-react-lite';
import AddressInfo from '@/components/combined/AddressInfo';
import AddressHeader from '@/components/combined/AddressHeader';
import getAddrService from '@/api/address';
import Dappservice from '@/api/dapp';
import Table from '@/components/base/Table';
import { gettext } from '@/utils/langsBook';
import { getContractColumns } from '@/constants/DApp';
import Icon from '@/components/base/Icon';
import EmptyList from '@/components/combined/EmptyList';
import { DEFAULT } from '@/constants';
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var dappservice = Dappservice();
var addrService = getAddrService();
var Address = function() {
    var ref;
    var router = useRouter();
    var refresh = refreshStore.refresh;
    var address = String((ref = router.query) === null || ref === void 0 ? void 0 : ref.address);
    var ref1 = useState(), addressInfo = ref1[0], setAddressInfo = ref1[1];
    var ref2 = useState(true), loading = ref2[0], setLoading = ref2[1];
    var ref3 = useState([]), data = ref3[0], setData = ref3[1];
    var ref4 = useState(''), extra = ref4[0], setExtra = ref4[1];
    useEffect(function() {
        if (refresh) {
            getAddress();
            getDappContracts();
        }
    }, [
        refresh
    ]);
    useEffect(function() {
        getAddress();
        getDappContracts();
    }, [
        address
    ]);
    var getAddress = useCallback(_asyncToGenerator(regeneratorRuntime.mark(function _callee() {
        var Result;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    setLoading(true);
                    _ctx.prev = 1;
                    _ctx.next = 4;
                    return addrService.getAddressDetail(address);
                case 4:
                    Result = _ctx.sent.Result;
                    setAddressInfo(Result);
                    _ctx.next = 11;
                    break;
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](1);
                    console.log(_ctx.t0);
                case 11:
                    setLoading(false);
                case 12:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                8
            ]
        ]);
    })), [
        address
    ]);
    var getDappContracts = useCallback(_asyncToGenerator(regeneratorRuntime.mark(function _callee() {
        var Result;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    setLoading(true);
                    _ctx.prev = 1;
                    _ctx.next = 4;
                    return dappservice.getDAppContractList({
                        address: address,
                        pos: 0,
                        limit: 100
                    });
                case 4:
                    Result = _ctx.sent.Result;
                    if (Result) {
                        setData(Result.ListData);
                        setExtra("".concat(Result.TotalNum, " Contracts"));
                    }
                    _ctx.next = 11;
                    break;
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](1);
                    console.log(_ctx.t0);
                case 11:
                    setLoading(false);
                case 12:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                8
            ]
        ]);
    })), [
        address
    ]);
    var isCore = useMemo(function() {
        return address === 'core:dapp';
    }, [
        address
    ]);
    return(/*#__PURE__*/ _jsx(AddressHeader, {
        children: /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(AddressInfo, _objectSpread({
                    target: address,
                    loading: loading
                }, addressInfo), address),
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex items-center w-full mt-[32px] mb-[12px] ",
                    children: [
                        /*#__PURE__*/ _jsx("span", {
                            className: "text-[18px] font-semibold font-inter-semibold",
                            children: gettext('Contracts List')
                        }),
                        isCore ? '' : /*#__PURE__*/ _jsxs("div", {
                            className: "flex-1 text-desc text-right align-middle",
                            children: [
                                /*#__PURE__*/ _jsx(Icon, {
                                    type: "bar",
                                    className: "mr-[8px] align-middle"
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    className: "align-middle text-[14px] text-desc",
                                    children: extra
                                })
                            ]
                        })
                    ]
                }),
                isCore ? /*#__PURE__*/ _jsx(EmptyList, {
                    text: /*#__PURE__*/ _jsxs("p", {
                        className: "w-[652px] text-center text-[#B0B3C0] leading-[30px] text-[14px] font-inter-regular",
                        children: [
                            "Please note that this is a ",
                            DEFAULT.NET,
                            " native contract, and the source code is currently unavailable. The source code will be released alongside the ",
                            DEFAULT.NET,
                            " blockchain codebase. Stay tuned!"
                        ]
                    })
                }) : /*#__PURE__*/ _jsx(Table, {
                    columns: getContractColumns(address),
                    data: data,
                    rowKey: "id",
                    loading: loading
                })
            ]
        })
    }));
};
export default WrapPage(observer(Address));
